<template>
  <div class="add-user-container">
    <el-card class="box-card" shadow="hover">
      <template #header>
        <div class="clearfix">
          <span>添加用户</span>
        </div>
      </template>
      
      <el-form :model="userForm" :rules="rules" ref="formRef" label-width="120px">
        <el-form-item label="账号" prop="username">
          <el-input v-model="userForm.username" placeholder="请输入账号"></el-input>
        </el-form-item>
        
        <el-form-item label="密码" prop="password">
          <el-input v-model="userForm.password" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
        
        <el-form-item label="用户ID">
          <el-input v-model="userForm.id" disabled placeholder="自动生成"></el-input>
        </el-form-item>
        
        <el-form-item label="权限等级">
          <el-select v-model="userForm.role" placeholder="选择一个已有的权限等级" style="width: 260px" :loading="roleLoading">
            <el-option v-for="r in roleList" :key="r.name" :label="r.label + '（' + r.name + '）'" :value="r.name" />
          </el-select>
          <span class="tip">选项来自「用户管理 → 权限管理」，没有想要的等级就去那里新建一个</span>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="submitForm">提交</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script setup>
import { ref, reactive, toRefs ,onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import axios from 'axios'

// 权限等级列表（下拉选项）
const roleList = ref([])
const roleLoading = ref(false)
const loadRoles = async () => {
  roleLoading.value = true
  try {
    const res = await axios.get('/adminapi/role/list')
    const d = res.data || {}
    roleList.value = d.roles || []
    if (!userForm.role) {
      const def = roleList.value.find(r => r.name === 'user') || roleList.value[0]
      if (def) userForm.role = def.name
    }
  } catch (e) {
    ElMessage.error('读取权限等级失败：' + (e.response?.data?.message || e.message))
  } finally {
    roleLoading.value = false
  }
}

onMounted(() => {
    generateId()
    loadRoles()
})
// 表单数据
const formRef = ref(null)
const userForm = reactive({
  username: '',
  password: '',
  id: '',
  role: 'user' // 默认普通管理员，可选「权限管理」里建好的任意等级
})

// 表单验证规则
const rules = reactive({
  username: [
    { required: true, message: '请输入账号', trigger: 'blur' },
    { min: 1, max: 20, message: '账号长度在 1 到 20 个字符', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' },
    { min: 6, message: '密码长度至少 6 个字符', trigger: 'blur' }
  ]
})

// 生成唯一ID
const generateId = () => {
  // 方法1: 使用时间戳和随机数生成唯一ID
  const timestamp = Date.now().toString(36)
  const random = Math.random().toString(36).substr(2, 5)
  userForm.id = `${timestamp}${random}`
  
}

// 提交表单
const submitForm = () => {
  formRef.value.validate((valid) => {
    if (valid) {
      if (!userForm.id) {
        ElMessage.warning('请先生成ID')
        return
      }
      
      // 准备提交数据
      const submitData = {
        username: userForm.username,
        password: userForm.password,
        id: userForm.id,
        role: userForm.role
      }
      
      // 发送 POST 请求
      axios.post('/adminapi/admin/add', submitData)
        .then(response => {
          const res = response.data || {}
          if (res.code === 1001) { // 假设1001是ID重复错误码
            ElMessage.warning('ID已存在，请重新生成')
            userForm.id = '' // 清空ID让用户重新生成
          } else if (res.code === 200) {
            ElMessage.success('添加用户成功')
            // 重置表单
            resetForm()
            // 可以在这里添加关闭对话框或跳转到列表页的逻辑
          } else {
            ElMessage.error(res.message || '添加用户失败')
          }
        })
        .catch(error => {
          console.error('请求出错:', error)
          ElMessage.error('网络错误，请稍后重试')
        })
    } else {
      ElMessage.warning('请完成表单验证')
      return false
    }
  })
}

// 重置表单
const resetForm = () => {
  formRef.value.resetFields()
  userForm.id = ''
  const def = roleList.value.find(r => r.name === 'user') || roleList.value[0]
  userForm.role = def ? def.name : 'user'
  generateId()
}


</script>

<style scoped>
.add-user-container {
  max-width: 600px;
  margin: 20px auto;
  padding: 0 20px;
}

.box-card {
  margin-top: 20px;
}

/* 调整生成ID按钮位置 */
.el-form-item__content {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.tip { font-size: 12px; color: #909399; }
</style>  